<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__group">
        <div class="weui-cells__title">活动信息</div>
        <custom-layout class="weui-cells" :view-config="customViewConfig">
          <div class="weui-cell" slot="sa_name">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_name || "活动名称"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_name"
                placeholder="请输入"
              />
            </div>
          </div>
          <datetime-field slot="sa_begintime" :label="customLabel.sa_begintime || '起始时间'" v-model="form.main.sa_begintime" />
          <datetime-field slot="sa_endtime" :label="customLabel.sa_endtime || '结束时间'" v-model="form.main.sa_endtime" />
          <div class="weui-cell" slot="sa_address">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_address || "活动地点"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_address"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sa_organizer">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_organizer || "主办单位"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_organizer"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sa_coorganizer">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_coorganizer || "协办单位"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_coorganizer"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sa_guest">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_guest || "特邀嘉宾"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_guest"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sa_desc">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.sa_desc || '活动详情'"
                rows="3"
                v-model="form.main.sa_desc"
                maxlength="100"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.sa_desc ? form.main.sa_desc.length : 0
                }}</span
                >/100
              </div>
            </div>
          </div>
        </custom-layout>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells__title">活动联系人</div>
        <custom-layout class="weui-cells" :view-config="customViewConfig">
          <employee-field slot="sa_contact"
            :label="customLabel.sa_contact || '联系人'"
            v-model="form.main.sa_contact"
            @select="onSelectEmployee"
          />
          <div class="weui-cell" slot="sa_contact_mob">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.sa_contact_mob || "联系电话"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_contact_mob"
                placeholder="请输入联系电话"
              />
            </div>
          </div>
        </custom-layout>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells__title">宣传资料</div>
        <div class="weui-cells">
          <file-field v-model="form.main.sa_attach" />
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>人员{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-cell" slot="su_username">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.su_username || "姓名"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.su_username"
                placeholder="请输入姓名"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after"  slot="su_gender">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.su_gender || "性别"}}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="item.su_gender"
                placeholder="请选择"
              >
                <option>男</option>
                <option>女</option>
              </select>
            </div>
          </div>
          <div class="weui-cell" slot="su_mobile">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.su_mobile || "联系电话"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.su_mobile"
                placeholder="请输入联系电话"
              />
            </div>
          </div>
          <div class="weui-cell" slot="su_job">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.su_job || "职位"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.su_job"
                placeholder="请输入职位"
              />
            </div>
          </div>
          <div class="weui-cell" slot="su_corpname">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.su_corpname || "企业名称"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.su_corpname"
                placeholder="请输入职位企业名称"
              />
            </div>
          </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div class="weui-cells__group" v-if="!form.items || !form.items.length">
        <div class="weui-cells">
          <a
            href="javascript:"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加人员</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import FileField from "@/components/field/FileField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";
import Session from "@/util/session.js";

export default {
  components: {
    CustomLayout,
    DatetimeField,
    FileField,
    EmployeeField,
  },
  mixins: [process],
  data() {
    var session = Session.get(),
      account = session == null ? null : session.account,
      company = account == null ? null : account.defaultCompany;
    return {
      baseUrl: "/api/crm/activity",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "SaleActivity",
      xtype: "crm-activity-formpanel",
      form: {
        main: {
          sa_begintime: this.dateFormat(new Date(), "yyyy-MM-dd 09:00:00"),
          sa_endtime: this.dateFormat(new Date(), "yyyy-MM-dd 18:00:00"),
          sa_contact: null,
          sa_contact_mob: null,
          sa_organizer: company == null ? null : company.name,
        },
      },
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.sa_name) {
        me.$weui.topTips("请填写活动名称", 2000);
      } else if (!main.sa_address) {
        me.$weui.topTips("请填写活动地点", 2000);
      } else if (!main.sa_organizer) {
        me.$weui.topTips("请填写主办单位", 2000);
      } else if (!main.sa_contact || !main.sa_contact_mob) {
        me.$weui.topTips("请填写联系人", 2000);
      } else {
        if (!items) {
          checked = true;
        } else {
          var count = 0;
          items.forEach(function (item) {
            if (!item.su_username) {
              me.$weui.topTips(`第${count + 1}行人员未填写姓名`, 2000);
              return false;
            } else if (!item.su_mobile) {
              me.$weui.topTips(`第${count + 1}行人员未填写手机号`, 2000);
              return false;
            } else {
              count++;
              item.su_detno = count;
            }
          });
          checked = count == items.length;
        }
      }
      if (checked) {
        me.p_save();
      }
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.sa_contact_mob = selection.em_mobile;
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      items.splice(index, 1);
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({});
    },
  },
};
</script>